import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { createQueryKey } from '@/lib/react-query'
import OfferPRApprovalService from '../services/offerPRApproval.service'

const useOfferPRApproval = () => {
  const service = new OfferPRApprovalService()
  const queryKey = createQueryKey(API_RESOURCE.OFFER)

  const useInvitePRUser = useAction({
    mutationFn: service.invitePRUser,
    queryKey: queryKey,
    message: 'Successfully invited user to PR approval',
  })

  const useReplyPRInvitation = useAction({
    mutationFn: service.replyPRInvitation,
    queryKey: queryKey,
    message: 'Successfully replied to PR invitation',
  })

  const useDeletePRInvitedUsers = useAction({
    mutationFn: service.deletePRInvitedUsers,
    queryKey: queryKey,
    message: 'Successfully removed invited users',
  })

  return {
    useInvitePRUser,
    useReplyPRInvitation,
    useDeletePRInvitedUsers,
  }
}

export default useOfferPRApproval
